var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 5.532c0-1.156 0-1.734.242-2.064a1.25 1.25 0 0 1 .892-.505c.408-.038.904.26 1.895.854l6.39 3.835c.863.517 1.294.776 1.456 1.12.142.3.158.645.044.958-.13.357-.535.655-1.346 1.25l-6.39 4.686c-1.027.753-1.54 1.129-1.968 1.117a1.25 1.25 0 0 1-.952-.482C5 15.962 5 15.326 5 14.053z"
  })));
};
export default SvgPlay;